import {forwardRef, HTMLProps, ReactNode, Ref} from 'react';

interface IProps extends Omit<HTMLProps<HTMLDivElement>, 'ref'> {
  isFlex?: boolean;
  isFixed?: boolean;
  bgClassName?: string;
  bgColor?: string;
  height?: string;
  children?: ReactNode;
}

function FullBg(
  {
    isFlex,
    isFixed,
    bgClassName,
    bgColor,
    height,
    className,
    children,
    ...rest
  }: IProps,
  ref: Ref<HTMLDivElement>
) {
  return (
    <div
      ref={ref}
      className={cn(className, {
        'inset-x-0 fixed': isFixed,
        'inset-x-auto relative': !isFixed,
        flex: isFlex,
      })}
      {...rest}
    >
      <div
        className={cn(
          'left-1/2 top-0 ml-[-50vw] absolute w-[100vw] -z-1',
          bgClassName
        )}
        style={{
          height: height || '100%',
          background: bgColor || undefined,
        }}
      />
      {children}
    </div>
  );
}

export default forwardRef(FullBg);
